import React from 'react';

import { serviceChargeTypes } from 'lib/constants/constants';
import useModal from 'lib/hooks/useModal';

import Icon from 'components/shared/Icon/Icon';
import Select from 'components/shared/Select/Select';
import Typography from 'components/shared/Typography/Typography';

import Wrapper from '../Wrapper/Wrapper';

import NdcCodeModal from './components/NdcCodeModal';

const CodingSection = ({ formik }) => {
  const { isOpen, openModal, closeModal } = useModal();

  const onSave = (ndcCodes, type) => {
    formik.setFieldValue('ndc_codes', ndcCodes);
    formik.setFieldValue('searchType', type);
    closeModal();
  };

  return (
    <Wrapper isColumn>
      {/* Row: Default charge type, Time Length with stepper, NDC Code */}
      <div className="grid grid-cols-2 items-end gap-4">
        <Select
          name="charge_type"
          label="Default charge type"
          isClearable={false}
          parentClassName="flex w-full flex-col"
          options={
            formik.values.procedure_code
              ? serviceChargeTypes
              : serviceChargeTypes?.filter((type) => type.value !== 'copay')
          }
          id="serviceChargeTypeSelect"
          value={formik.values.charge_type}
          placeholder="Select default charge type"
          onChange={(value) => formik.setFieldValue('charge_type', value)}
          error={formik.touched.charge_type && formik.errors.charge_type}
        />
        
        <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-1 flex-1">
          <label className="text-sm font-medium text-neutral-800">
            Time length (minutes)
          </label>
          <div className="flex h-[40px] items-center rounded-[4px] border border-solid border-neutral-200 bg-white">
            <button
              type="button"
              className="flex h-full w-[40px] items-center justify-center text-neutral-600 hover:bg-neutral-50"
              onClick={() => {
                const currentValue = parseInt(formik.values.time_length) || 0;
                if (currentValue > 0) {
                  formik.setFieldValue('time_length', currentValue - 1);
                }
              }}
            >
              −
            </button>
            <input
              type="number"
              name="time_length"
              id="timeLengthInput"
              data-qa="timeLength-input"
              min="0"
              value={formik.values.time_length}
              onChange={(e) => {
                const value = Math.max(0, parseInt(e.target.value) || 0);
                formik.setFieldValue('time_length', value);
              }}
              className="h-full w-[80px] border-0 bg-transparent text-center text-sm outline-none"
            />
            <button
              type="button"
              className="flex h-full w-[40px] items-center justify-center text-neutral-600 hover:bg-neutral-50"
              onClick={() => {
                const currentValue = parseInt(formik.values.time_length) || 0;
                formik.setFieldValue('time_length', currentValue + 1);
              }}
            >
              +
            </button>
          </div>
          {formik.touched.time_length && formik.errors.time_length && (
            <span className="text-xs text-danger-500">{formik.errors.time_length}</span>
          )}
        </div>

        {/* NDC Code */}
        <div className="flex flex-col gap-1 flex-1">
          <label className="text-sm font-medium text-neutral-800">
            NDC Code
          </label>
          <button
            type="button"
            className="flex items-center gap-2 text-primary-500 hover:text-primary-600 h-[40px]"
            onClick={openModal}
          >
            <Icon icon="add-square-mono" size={20} color="primary" />
            <span className="text-sm font-medium">Add NDC Code</span>
          </button>
        </div>
        </div>
      </div>
      {isOpen && (
        <NdcCodeModal
          isOpen={isOpen}
          initialCodes={formik.values.ndc_codes}
          onClose={closeModal}
          onSave={onSave}
          type={formik.values.searchType}
        />
      )}
    </Wrapper>
  );
};

export default CodingSection;
